import Layout from '@/layout'

const hospitalManage = {
    path: '/operation',
    component: Layout,
    children: [
        {
            path: 'banner',
            name: 'bannerList',
            component: () => import('@/views/doctor/operation/banner')
        },
        {
            path: 'banner/add',
            name: 'bannerAdd',
            component: () => import('@/views/doctor/operation/bannerAdd'),
            meta: { activeMenu: '/operation/banner' }
        }, {
            path: 'banner/editor',
            name: 'bannerEditor',
            component: () => import('@/views/doctor/operation/bannerEditor'),
            meta: { activeMenu: '/operation/banner' }
        },
        {
            path: 'program',
            name: 'programList',
            component: () => import('@/views/doctor/operation/program')
        },
        {
            path: 'program/add',
            name: 'programAdd',
            component: () => import('@/views/doctor/operation/programAdd'),
            meta: { activeMenu: '/operation/program' }
        },
        {
            path: 'program/editor',
            name: 'programEditor',
            component: () => import('@/views/doctor/operation/programEditor'),
            meta: { activeMenu: '/operation/program' }
        },
        {
            path: 'consultation',
            component: () => import('@/views/doctor/operation/consultation'),
            meta: { activeMenu: '/operation/consultation' }
        },
        {
            path: 'consultation/academician',
            component: () => import('@/views/doctor/operation/consultationAcademician'),
            meta: { activeMenu: '/operation/consultation' }
        },
        {
            path: 'consultation/multidisciplinary',
            component: () => import('@/views/doctor/operation/consultationMultidisciplinary'),
            meta: { activeMenu: '/operation/consultation' }
        },
        {
            path: 'consultation/single',
            component: () => import('@/views/doctor/operation/consultationSingle'),
            meta: { activeMenu: '/operation/consultation' }
        },
        // 自定义模块管理
        {
            path: 'moduleManage',
            name: 'moduleManage',
            component: () => import('@/views/doctor/operation/moduleManage'),
            meta: { activeMenu: '/operation/moduleManage' }
        },
        // 首页按钮管理
        {
            path: 'btnManage',
            name: 'btnManage',
            component: () => import('@/views/doctor/operation/btnManage'),
            meta: { activeMenu: '/operation/btnManage' }
        },
        // 标签管理
        {
            path: 'labelManage',
            name: 'labelManage',
            component: () => import('@/views/doctor/operation/labelManage'),
            meta: { activeMenu: '/operation/labelManage' }
        },
        // push群发
        {
            path: 'pushMessage',
            name: 'pushMessage',
            component: () => import('@/views/doctor/operation/pushMessage'),
            meta: { activeMenu: '/operation/pushMessage' }
        },
        // 新增push群发
        {
            path: 'pushMessage/:pushId',
            name: 'pushMessageDetail',
            component: () => import('@/views/doctor/operation/pushMessageDetail'),
            meta: { activeMenu: '/operation/pushMessage' }
        }
    ]
}

export default hospitalManage
